import React, { useContext } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { Colors } from '../colors/colors';
import Icon from './Icon';
import { endSession } from '../../API/repositories/user';
import { LOGIN_PATH } from '../../API/constants/auth';
import { AuthContext } from '../contexts/authContext';

const Wrapper = styled.div`
	width: 30px;
	height: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
`;

const Logout = () => {
	const navigate = useNavigate();
	const { setAuthUser } = useContext(AuthContext);

	const handleLogout = async () => {
		await endSession();
		setAuthUser(null);
		navigate(LOGIN_PATH);
	};
	return (
		<Wrapper onClick={() => handleLogout()} className='animation-scale'>
			<Icon name='right-from-bracket' style={{ color: Colors.red, fontSize: 16 }} />
		</Wrapper>
	);
};

export default Logout;
